import { clsx } from 'clsx';

import { getInputGrid } from '@monoimin/utils/helpers';

import { AnimatedLabel } from '@monoimin/atoms';

import type { InputProps } from '@monoimin/forms/gravity-form/types';

export const TextInput = ({
  label,
  id,
  adminLabel,
  isRequired,
  type,
  value,
  customId,
  labelPlacement,
  description,
  layoutGridColumnSpan = 12,
  classNames,
  withPlaceholder,
  onChange,
}: InputProps) => {
  const isLabelInside = labelPlacement === 'hidden_label';
  const gridColumn = getInputGrid(layoutGridColumnSpan);
  return (
    <div className={clsx('relative', classNames?.input, gridColumn)}>
      {!withPlaceholder && !isLabelInside && (
        <div className='flex flex-col mb-2'>
          <label className='text-xl' htmlFor={customId}>
            {label}
          </label>
          {description && <span className=''>{description}</span>}
        </div>
      )}
      <div
        className={clsx(
          classNames?.inputWrapper || 'w-full group h-15 md:h-16'
        )}
      >
        <input
          onChange={onChange}
          id={customId}
          type={type}
          name={adminLabel || customId}
          required={isRequired}
          placeholder={withPlaceholder ? label : ''}
          autoComplete={'on'}
          className={clsx(
            'peer bg-white w-full h-full pt-7 pb-3.5 px-3.5 text-xl border border-line', // focus:outline-0
            classNames?.inputTag
          )}
        />

        {!withPlaceholder && isLabelInside && (
          <AnimatedLabel
            inputValue={value}
            id={id}
            className={classNames?.label}
          >
            {label}
          </AnimatedLabel>
        )}
      </div>
    </div>
  );
};
